import { ApplicationDto } from 'api/ApplicationApi';
import { HttpClient } from 'api/HttpClient';

export interface UpdateContractorInformationRequestDto {
  applicationId: string;
  contractorIsLocated: boolean;
  businessName?: string;
  city?: string;
  state?: string;
  contactFirstName?: string;
  phoneNumber?: string;
}

export interface ContractorInformationResponseDto {
  contractorIsLocated: boolean | null;
  businessName: string | null;
  city: string | null;
  state: string | null;
  contactFirstName: string | null;
  phoneNumber: string | null;
}

export default class ContractorInformationApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/small-loan-program/contractor-information');
  }

  public async get(applicationId: string): Promise<ContractorInformationResponseDto> {
    return this.instance.get(`?applicationId=${applicationId}`).then((response) => response.data);
  }

  public async update(
    contractorInformation: UpdateContractorInformationRequestDto,
  ): Promise<ContractorInformationResponseDto> {
    return this.instance.put('/', contractorInformation).then((response) => response.data);
  }
}

export const contractorInformationApi = new ContractorInformationApi();
